//import type { MangoAccount, MangoClient, MangoGroup } from "@blockworks-foundation/mango-client";
//import type { Market } from "@project-serum/serum";
import type { FC } from "react";
import React, { useCallback, useContext, useState } from "react";

import { useDriftProtocol } from "../hooks/margin/useDriftProtocol";
//import { useMangoMarkets } from "../hooks";
import { useZeroOne } from "../hooks/margin/useZeroOne";
import { useZetaMarkets } from "../hooks/margin/useZetaMarkets";
import type { MarginAccount, MarginFundingRate, MarginPlatforms } from "../types/margin";

type MarginContextState = {
  refreshContext: () => void;
  setMarginBalance: (balance: number) => void;
  marginBalance: number;
  marginAccounts: MarginAccount[];
  /*mangoHelpers: {
    mangoAccounts: MangoAccount[];
    mangoClient: MangoClient;
    mangoGroup: MangoGroup | undefined;
    spotMarkets: Market[];
  };*/
  fundingRates: MarginFundingRate<MarginPlatforms>[];
};

const MarginContext = React.createContext<null | MarginContextState>(null);

export const MarginContextProvider: FC<{ children?: React.ReactNode }> = ({ children }) => {
  const [marginBalance, setMarginBalance] = useState(0);
  const memoizedSetMarginBalance = useCallback((balance) => setMarginBalance(balance), []);

  // Disable mango for now as V4 will likely be similar to V3
  /*const {
    marginAccounts: mangoMarginAccounts,
    mangoAccounts,
    mangoClient,
    mangoGroup,
    spotMarkets,
    refreshMango,
  } = useMangoMarkets();*/
  const { zeroOneMarginAccounts, refreshZeroOne } = useZeroOne();
  //const fundingRates = useFundingRates();
  const { marginAccounts: zetaMarginAccounts } = useZetaMarkets();
  const refreshContext = () => {
    //refreshMango();
    refreshZeroOne();
  };
  const driftMarginAccounts = useDriftProtocol();

  return (
    <MarginContext.Provider
      value={{
        refreshContext,
        marginAccounts: [
          /*...mangoMarginAccounts,*/
          ...zeroOneMarginAccounts,
          ...zetaMarginAccounts,
          ...driftMarginAccounts,
        ],
        /*mangoHelpers: {
          mangoAccounts,
          mangoClient,
          mangoGroup,
          spotMarkets,
        },*/
        fundingRates: /*fundingRates["Mango Markets"] ?? []*/ [],
        setMarginBalance: memoizedSetMarginBalance,
        marginBalance,
      }}
    >
      {children}
    </MarginContext.Provider>
  );
};

export function useMarginContext(): MarginContextState {
  const ctx = useContext(MarginContext);
  if (ctx === null) {
    throw new Error("Context not available");
  }
  return ctx;
}
